
import React from "react";
import {Button, Col, Container, Row, Accordion, Card} from "react-bootstrap";

import {IndicatorConfigView} from '../IndicatorConfigView';
import {StrategyConfigView} from '../StrategyConfigView';
import {OrderSummaryView} from '../OrderSummaryView';

import {StockCharts} from '../StockCharts';
import {DailyOrderList} from '../DailyOrderList';
import {DISPLAY_CHARTS} from '../constants';


function ChartDailyResults(params) {

    const configData = params.summaryData.config;
    const data = params.data;

    const display = params.display;
    console.log("display.." + display);
    let view = <div>Ready to load charts!!</div>

    if(configData === null || configData === undefined){
        view = <div>Config data Not found for selected day</div>
    } else if (display){
        view =
            <Container>
                <Row>
                    <Col>
                    <Accordion key={'tab.config'} defaultActiveKey={'nno'}>
                        <Card>
                            <Card.Header>
                                <Accordion.Toggle as={Button} variant="link" eventKey={'tab.config'}>
                                    Config: {configData.name}
                                </Accordion.Toggle>
                            </Card.Header>
                            <Accordion.Collapse eventKey={'tab.config'}>
                                <Card.Body>
                                    <div>Indicator Config</div>
                                    <IndicatorConfigView config={configData} />
                                    <div>Strategy Config</div>
                                    <StrategyConfigView config={configData} />
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Accordion key={'tab.orders'} defaultActiveKey={'off'}>
                            <Card>
                                <Card.Header>
                                    <Accordion.Toggle as={Button} variant="link" eventKey={'tab.orders'}>
                                        Orders: {params.summaryData.totalOrders} PnL: {params.summaryData.totalPnL}
                                    </Accordion.Toggle>
                                </Card.Header>
                                <Accordion.Collapse eventKey={'tab.orders'}>
                                    <Card.Body>
                                        Order Summary
                                        <OrderSummaryView summaryData={params.summaryData} />
                                        Order List
                                        <DailyOrderList orderList={params.orderList} />
                                    </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                        </Accordion>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <StockCharts chartData={data} config={configData} symbolOptions={DISPLAY_CHARTS} isFullConfig={true}/>
                    </Col>
                </Row>
            </Container>
    }
    return view;
}
export {ChartDailyResults}
